import { render, staticRenderFns } from "./tblProjectRoute.vue?vue&type=template&id=82de3e1e&scoped=true"
import script from "./tblProjectRoute.vue?vue&type=script&lang=js"
export * from "./tblProjectRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82de3e1e",
  null
  
)

export default component.exports